import { TypographyXS } from "@/components/typography/XS";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import React from "react";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  error?: string | null;
}

const CreateAppDetail = ({
  id,
  label,
  children,
  className,
  error,
  ...rest
}: Props) => {
  return (
    <div className="grid grid-cols-[20%_1fr] items-center gap-x-4 gap-y-1">
      <Label
        htmlFor={id}
        className="text-right text-brand-gray-700 dark:text-brand-gray-100"
      >
        {label}
      </Label>
      <Input
        className={cn(
          "pt-1.5 dark:border-brand-gray-700 text-brand-gray-700 dark:text-brand-gray-100",
          className
        )}
        {...rest}
      />
      {error && (
        <TypographyXS className="col-start-2 ml-2 text-brand-error dark:text-brand-error font-normal tracking-wide">
          {error}
        </TypographyXS>
      )}
      {children}
    </div>
  );
};

export default CreateAppDetail;
